import useResources from "../../../hooks/UseResources";
import {getAllVisitLocations} from "../../../services/VisitLocationService";

export default function useVisitLocations() {
    return useResources(getAllVisitLocations, "data");
}
